module.exports = __webpack_public_path__ + "img/深色图例2.5232aa2b.png";